"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _default =
/*#__PURE__*/
(0, _reactEmotion.default)("span", {
  target: "css-1lv4nvg0"
})("width:", function (props) {
  return "".concat(props.width, "px");
}, ";");

exports.default = _default;